import React, { FC, useCallback, useState } from 'react'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { toast } from 'react-toastify'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { ContactUsRequestDto } from '@sparling/financial-common'
import { GreenButton } from '../../../components/Buttons/GreenButton'
import { rxios } from '../../../utils/NetUtils'
import { InputField } from '../../../components/InputField'

type Inputs = {
  name: string
  email: string
  phone: string
  message: string
}

const useStyle = makeStyles((theme: Theme) => ({
  container: {
    marginTop: 176,
    paddingTop: 129,
    textAlign: 'center',
    borderTop: '1px solid rgba(0,0,0,0.24)',
  },
  section: {
    maxWidth: 496,
  },
  title: {
    textAlign: 'left',
    color: theme.palette.primary.dark,
  },
  form: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    marginTop: 64,
  },
}))

const resolver = classValidatorResolver(ContactUsRequestDto)

export const LeftPanel: FC = () => {
  const classes = useStyle()

  const formMethods = useForm<Inputs>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
    resolver,
  })
  const { handleSubmit, reset } = formMethods
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit: SubmitHandler<Inputs> = useCallback(
    async (data: Inputs) => {
      let cleanupFunction = false
      setLoading(true)

      rxios.post('contactUs', data).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          if (next.success) {
            toast.success('Message sent successfully')
            if (!cleanupFunction) setLoading(false)
          }
        },
        (error) => {
          toast.error(error.response.data.message)
          setLoading(false)
        },
        () => {
          reset()
          setLoading(false)
        },
      )
      cleanupFunction = true
    },
    [reset],
  )

  return (
    <Grid className={classes.container}>
      <Grid className={classes.section}>
        <Typography variant="h1" className={classes.title}>
          Send Us A Message
        </Typography>

        <FormProvider {...formMethods}>
          <form className="root" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Grid container className={classes.form}>
              <InputField inputName="name" inputType="text" labelName="Your Name" required />
              <InputField inputName="email" inputType="text" labelName="Your Email" required />
              <InputField inputName="phone" inputType="text" labelName="Your Phone" required />
              <InputField inputName="message" inputType="text" labelName="Your Message" required />

              <GreenButton type="submit" width="100%" mt={32} text="Send message" />
            </Grid>
          </form>
        </FormProvider>
      </Grid>
    </Grid>
  )
}
